// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"2f2e76ad","412":"cc9f6d73"}[chunkId] + ".chunk.js";
};